import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, Table, Col, Row,Alert  } from "react-bootstrap";
import * as XLSX from "xlsx";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";
import axios from "axios";

export default function FilteredFamilies() {

  const location = useLocation();
  const families = location.state?.data || [];
  // Set when a module (Spiritual, Vocational, Medical, School Enrollment, ACT) was exported
  const columns = location.state?.columns || null;
  const moduleLabel = location.state?.moduleLabel || "";
  const isModule = Array.isArray(columns) && columns.length > 0;

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [requested, setRequested] = useState(false);
  const [message, setMessage] = useState(null);
  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
  // ⭐ Download Excel
  const downloadExcel = () => {
    if (isModule) {
      // Module export: only the module's columns, with readable headers
      const rows = families.map((row) => {
        const out = {};
        columns.forEach((col) => {
          out[col.label] = row[col.key] ?? "";
        });
        return out;
      });
      const worksheet = XLSX.utils.json_to_sheet(rows, {
        header: columns.map((col) => col.label),
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, moduleLabel.substring(0, 31) || "Records");
      XLSX.writeFile(workbook, `Filtered_${moduleLabel.replace(/\s+/g, "_") || "Records"}.xlsx`);
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(families);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Families");
    XLSX.writeFile(workbook, "Filtered_Families.xlsx");
  };

  // ✅ Select single
  const handleSelect = (fsf_id) => {
    if (selectedIds.includes(fsf_id)) {
      setSelectedIds(selectedIds.filter(id => id !== fsf_id));
    } else {
      setSelectedIds([...selectedIds, fsf_id]);
    }
  };

  // ✅ Select all
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedIds([]);
    } else {
      // Unique family ids (module rows can repeat a family; ACT members may have none)
      setSelectedIds([...new Set(families.map(f => f.p_id).filter(Boolean))]);
    }
    setSelectAll(!selectAll);
  };
   
  // ✅ Download ZIP
  const downloadBulkPDF = async () => {
    
    if (!selectedIds.length) {
      alert("Select at least one family");
      return;
    }
   
   if(selectedIds.length > 25){
    alert("You can select up to 25 families for PDF download at a time.");
    return;
   }
   setLoading(true);

    try {
      const res = await axios.post(process.env.REACT_APP_API_URL + '/bulk-short-pdf', {
        ids: selectedIds
      });
      
      if (res.data.success) {
          setMessage(res.data.message || "Download started");
          setLoading(false);
          setRequested(true);
      } else {
        alert(res.data.message || "Failed");
      }

    } catch (err) {
       setLoading(false);
          setRequested(false);
      console.error(err);
      alert("Server error");
    }
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">Filters</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">Home</Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">Filtered Families</Link>
                </li>
                <li className="mc-breadcrumb-item">Filters</li>
              </ul>
            </div>
          </div>
        </Col>

        <div className="mc-card" style={{ padding: "20px" }}>
          <h3>{isModule ? `Filtered ${moduleLabel} Records` : "Filtered Families"}</h3>

          <Button variant="success" onClick={downloadExcel} style={{ marginRight: "10px" }}>
            Download Excel
          </Button>
          {
            loading ? (
              <Button variant="primary" disabled>
                Download PDF { requested ? "Requested" : "Requesting... (please wait)" }
              </Button>
            ) : (
              <Button variant="primary" onClick={downloadBulkPDF}>
                Download PDF ZIP ({selectedIds.length})
              </Button>
            )
          }
        {message && <Alert   variant="success" dismissible className="mt-3">{message}</Alert>}
          <div className="table-responsive" style={{ marginTop: "20px" }}>
            {isModule ? (
            <Table bordered hover>
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" onChange={handleSelectAll} checked={selectAll} />
                  </th>
                  <th>#</th>
                  {columns.map((col) => (
                    <th key={col.key}>{col.label}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {families.length === 0 ? (
                  <tr>
                    <td colSpan={columns.length + 2}><center>No data found...</center></td>
                  </tr>
                ) : (
                  families.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="checkbox"
                          disabled={!row.p_id}
                          checked={!!row.p_id && selectedIds.includes(row.p_id)}
                          onChange={() => handleSelect(row.p_id)}
                        />
                      </td>
                      <td>{index + 1}</td>
                      {columns.map((col) => (
                        <td key={col.key}>{row[col.key] ?? ""}</td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
            ) : (
            <Table bordered hover>
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" onChange={handleSelectAll} checked={selectAll} />
                  </th>
                  <th>#</th>
                  <th>Family Request ID</th>
                  <th>FSF ID</th>
                  <th>Name</th>
                  <th>CNIC</th>
                  <th>Mobile</th>
                  <th>City</th>

                  {/* NEW FIELDS */}
                  <th>Donor</th>

                  <th>Brick Kiln Name</th>
                  <th>Owner Name</th>
                  <th>Owner Mobile</th>
                  <th>Owner CNIC</th>
                  <th>Brick Kiln Address</th>

                  {/* OLD FIELDS */}
                  <th>Loan Amount</th>
                  <th>Transportation</th>
                  <th>Housing</th>
                  <th>Meal</th>
                  <th>Affidavit</th>
                  <th>Utility</th>
                  <th>Medical</th>
                  <th>Food Ration</th>
                  <th>Other</th>
                  <th>Khatta Amount</th>
                  <th>Estimated Business Cost</th>

                  <th>Relocation Total</th>

                  <th>Business Type</th>
                  <th>Equipment Cost</th>
                </tr>
              </thead>

              <tbody>
                {families.length === 0 ? (
                  <tr>
                    <td colSpan={30}><center>No data found...</center></td>
                  </tr>
                ) : (
                  families.map((f, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedIds.includes(f.p_id)}
                          onChange={() => handleSelect(f.p_id)}
                        />
                      </td>

                      <td>{index + 1}</td>
                      <td>{f.rfq_id}</td>
                      <td>{f.fsf_id}</td>
                      <td>{f.name}</td>
                      <td>{f.cnic}</td>
                      <td>{f.mobile}</td>
                      <td>{f.city_name}</td>

                      {/* NEW DATA */}
                      <td>{f.donor_name}</td>

                      <td>{f.brickkiln_name}</td>
                      <td>{f.brickkiln_owner}</td>
                      <td>{f.brickkiln_owner_cell}</td>
                      <td>{f.brickkiln_owner_cnic}</td>
                      <td>{f.brickkiln_address}</td>

                      {/* OLD DATA */}
                      <td>{f.loan_amount}</td>
                      <td>{f.transportation}</td>
                      <td>{f.housing}</td>
                      <td>{f.meal_amount}</td>
                      <td>{f.affidavit_amount}</td>
                      <td>{f.utility_amount}</td>
                      <td>{f.medical_amount}</td>
                      <td>{f.food_ration}</td>
                      <td>{f.other}</td>
                      <td>{f.khatta_amount}</td>
                      <td>{f.estimated_business_cost}</td>

                      <td><strong>{f.relocation_total}</strong></td>

                      <td>{f.business_type_name}</td>
                      <td>{f.equipment_cost}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
            )}
          </div>
        </div>
      </Row>
    </PageLayout>
  );
}